import { CanDeactivate, ChildrenOutletContexts } from '@angular/router';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationModalService } from '../components/confirmation-modal/confirmation-modal.service';
import { UserService } from '../../services/user.service';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Promise<boolean>;
}

@Injectable()
export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {
  constructor(
    private confirmationService: ConfirmationModalService,
    private userService: UserService,
    private translate: TranslateService,
    private contexts: ChildrenOutletContexts
  ) {}

  canDeactivate(component: ComponentCanDeactivate): boolean | Promise<boolean> {
    if (!this.userService.getUserStatus() || !component.canDeactivate || component.canDeactivate()) {
      return true;
    }

    return new Promise(resolve => {
      this.confirmationService.show({
        message: () => this.translate.instant('app.navigation.unsaved-changes-warning'),
        accept: () => resolve(true),
        reject: () => resolve(false),
      });
    });
  }

  /**
   * Checks if the currently active component has pending changes
   * @returns true if there are pending changes, false otherwise
   */
  hasPendingChanges(): boolean {
    if (!this.userService.getUserStatus()) {
      return false;
    }

    const context = this.contexts.getContext('primary');
    const component = context?.outlet?.component as ComponentCanDeactivate;

    return component?.canDeactivate?.() === false;
  }
}
